import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, of } from 'rxjs';
import { switchMap, catchError, tap, filter, take, map } from 'rxjs/operators';
import { AuthState } from '../store';

import * as fromStore from '../store';

export const CheckAuthGuard: CanActivateFn = () => {
  const store = inject(Store<AuthState>);

  return combineLatest([
    store.select(fromStore.getAuthChecked),
    store.select(fromStore.getAuthChecking),
    store.select(fromStore.getInsightCodeInitialized),
  ]).pipe(
    tap(([checked, checking, initialized]) => {
      if (!checking && !checked) {
        store.dispatch(fromStore.CheckAuth());
        return;
      }
      if (!checking && !initialized) {
        store.dispatch(fromStore.InitInsightCode());
      }
    }),
    map(([checked, checking, initialized]) => checked && !checking && initialized),
    filter(loaded => loaded),
    take(1),
    switchMap(() => of(true)),
    catchError(() => of(false))
  );
};
